import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { CoachSessionsScheduleButton } from 'features/sessions/components/ScheduleButton';

import { Typography } from 'shared/components/Typography';

export const SessionsEmptyState = () => (
  <Flex
    flexDirection="column"
    gap="var(--spacing02)"
    height="100%"
    justifyContent="center"
  >
    <Typography>🧐</Typography>
    <Typography
      type="heading"
      fontWeight="semibold"
      color="black"
      dataTestid="empty-session-list"
    >
      No sessions yet
    </Typography>
    <Typography type="meta" fontWeight="regular" color="gray">
      Start by adding a new session.
    </Typography>
    <Spacer size="lg zr zr">
      <CoachSessionsScheduleButton
        dataTestid="coach-sessions-schedule-btn"
        icon={
          <Icon
            width="12px"
            height="12px"
            name={iconNames.plus}
            stroke="var(--fgPrimaryInverse)"
          />
        }
        fullWidth={false}
      >
        Schedule session
      </CoachSessionsScheduleButton>
    </Spacer>
  </Flex>
);
